import { callApi } from "./api";

// api services
export const upload = (type, file) => {
  const data = new FormData();
  data.append("files[art]", file);
  data.append("type", type);
  const params = {
    headers: {
      "Content-Type": null
    },
    credentials: "include",
    method: "POST",
    body: data
  };

  let url = "userart/upload";
  return callApi(url, params).then((response) => {
    if (response.response) {
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};

export const fetchSingleUserArt = (userartId) => {
  let url = `userart/entity/${userartId}`;

  return callApi(url).then((response) => {
    if (response.response) {
      return { response: response.response };
    } else {
      if (response.error) {
        return { error: response.error };
      } else {
        // Return an empty object if a user has no images
        return { response: {} };
      }
    }
  });
};

export const fetchUserArt = (userId) => {
  let url = `userart/user/${userId}`;

  return callApi(url).then((response) => {
    if (response.response.length) {
      return { response: response.response };
    } else {
      if (response.error) {
        return { error: response.error };
      } else {
        // Return an empty object if a user has no images
        return { response: {} };
      }
    }
  });
};

export const unpublish = (id) => {
  let url = "userart/unpublish/" + id;
  return callApi(url).then((response) => {
    if (response.response) {
      //TODO return the id in the Drupal response
      response.response.userart_id = id;
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};
